export default __webpack_public_path__ + "static/media/fj_goshin.998d381b.jpg";